module.exports = __webpack_public_path__ + "static/img/bg-tr.12cbc38d.png";